import {
  FeedItemsViewDto,
  PendingItemViewDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const feedRequests = {
  getFeedItems: new EndpointDefinition<
    FeedItemsViewDto,
    null,
    {
      userId: string;
      'page-size': number;
      'sort-direction': 'ASC' | 'DESC';
      'after-item-id'?: number;
      type: string;
    }
  >({
    name: 'getFeedItems',
    route: '/feeds/items',
    method: 'GET',
  }),
  getPendingItems: new EndpointDefinition<
    PendingItemViewDto,
    null,
    {
      userId: string;
      type?: string;
    }
  >({
    name: 'getPendingItems',
    route: '/feeds/pending-items',
    method: 'GET',
  }),
};
